import type { RouteRecordRaw } from 'vue-router';
import { useBrandComponent } from '@/composables/useBrandComponent';

/**
 * Ruta del módulo Mis Pólizas v2.
 *
 * ⚠️  RUTA DE PREVISUALIZACIÓN (backlog 3, rebanada 1).
 *     Registrada append-only en `/private/policies` para poder ir viendo el
 *     avance por URL directa. **NO cambia el menú ni la ruta v1 `/private/policy`**:
 *     el switch de menú (apuntar el ítem "Mis Pólizas" a esta vista) va al cierre
 *     del proyecto — un módulo, un switch. Revertir = quitar este spread; no se
 *     borra nada de v1.
 *
 * ── REGLA 2 — cómo se carga la vista ────────────────────────────────────────
 * Se resuelve con `useBrandComponent`, NUNCA con `import()` directo, para que una
 * marca pueda sustituirla con su propio
 * `brand/src/modules/policies-v2/views/PoliciesView.vue`.
 *
 * ── REGLA 3 — filtra EXACTAMENTE igual que la v1 que sustituye ───────────────
 * Mismos `requiresPermission` / `minLevel` / `requiresSystemPermission` que la
 * ruta v1 `/private/policy` (name `Mis Pólizas`): `brokerin` · 20 · `my_policies`
 * (`src/router/PrivateRoutes.ts`). Si no, un usuario sin el permiso entraría a una
 * pantalla a la que hoy no tiene acceso.
 */
export const policiesRoutes: RouteRecordRaw[] = [
    {
        // path relativo, se cuelga de `/private` desde PrivateRoutes.ts → /private/policies
        path: 'policies',
        name: 'Mis Pólizas v2',
        component: useBrandComponent('modules/policies-v2/views/PoliciesView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Mis Pólizas',
            requiresPermission: 'brokerin',
            minLevel: 20,
            requiresSystemPermission: 'my_policies'
        }
    }
];
